module.exports = __webpack_public_path__ + "static/media/au-ct.eec87ac0.svg";